/* English presentation for the LensBath funnel only. Shopify owns all consent state and events. */
(() => {
  if (window.osLensBathPrivacyEnglish) return;
  window.osLensBathPrivacyEnglish = true;
  const translations = new Map(Object.entries({
    'Permissão para cookies': 'Cookie consent',
    'Nós e nossos parceiros, incluindo a Shopify, usamos cookies e outras tecnologias para personalizar sua experiência, exibir anúncios e realizar análises. Não usaremos cookies ou outras tecnologias para esses fins sem o seu consentimento. Saiba mais na': 'We and our partners, including Shopify, use cookies and other technologies to personalize your experience, show ads, and perform analytics. We will not use cookies or other technologies for these purposes without your consent. Learn more in our',
    'Política de privacidade': 'Privacy Policy',
    'Gerenciar preferências': 'Manage preferences',
    'Aceitar': 'Accept',
    'Recusar': 'Decline',
    'Preferências de cookies e privacidade': 'Cookie and privacy preferences',
    'Aceitar todos': 'Accept all',
    'Recusar todos': 'Decline all',
    'Salvar minhas escolhas': 'Save my choices',
    'Quem controla seus dados é você': 'You control your data',
    'Saiba mais sobre os cookies que utilizamos e escolha quais deles permitir.': 'Learn more about the cookies we use and choose which ones to allow.',
    'Obrigatórios': 'Essential',
    'Cookies necessários para que o site funcione corretamente, incluindo recursos como fazer login e adicionar itens ao carrinho.': 'Cookies required for the website to work correctly, including features such as logging in and adding items to your cart.',
    'Personalização': 'Personalization',
    'Cookies que armazenam detalhes sobre suas ações para personalizar sua próxima visita ao site.': 'Cookies that store details about your actions to personalize your next visit to the website.',
    'Estes cookies são usados por nós e por nossos Parceiros, incluindo a Shopify, para otimizar as comunicações de marketing e exibir anúncios para você em outros sites.': 'These cookies are used by us and our partners, including Shopify, to improve marketing communications and show you ads on other websites.',
    'Análise': 'Analytics',
    'Cookies que nos ajudam a entender como você interage com o site. Usamos esses dados para identificar áreas que podem ser melhoradas.': 'Cookies that help us understand how you interact with the website. We use this data to identify areas for improvement.'
  }));
  const selector = '#shopify-pc__banner, #shopify-pc__prefs__dialog';
  function translate() {
    document.querySelectorAll(selector).forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const key = node.nodeValue.trim();
        if (translations.has(key)) node.nodeValue = node.nodeValue.replace(key, translations.get(key));
      }
    });
  }
  translate();
  const observer = new MutationObserver(records => {
    if (records.some(r => r.target.parentElement?.closest(selector) || [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches(selector) || n.querySelector(selector))))) translate();
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
